// Parse and stringify URL query strings
// {@link https://github.com/sindresorhus/query-string/pull/148#issuecomment-399666865}
export default {
  parse: function parse(queryString) {
    const query = {};
    const pairs = (queryString[0] === '?'
      ? queryString.substr(1)
      : queryString
    ).split('&');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  },
};



// WEBPACK FOOTER //
// ./src/utils/query-string.js